(() => {
  if (customElements.get('preorder-shopper')) return;

  const clock = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Sao_Paulo',
    weekday: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  });
  const instances = new Set();
  let timer;

  function isOpen(now = new Date()) {
    const parts = Object.fromEntries(clock.formatToParts(now).map(({ type, value }) => [type, value]));
    const minutes = Number(parts.hour) * 60 + Number(parts.minute);
    if (parts.weekday === 'Sat') return minutes >= 540 && minutes < 780;
    if (parts.weekday === 'Sun') return false;
    return minutes >= 510 && minutes < 1050;
  }

  function refreshAll() {
    const open = isOpen();
    instances.forEach((instance) => instance.refresh(open));
  }

  function register(instance) {
    instances.add(instance);
    instance.refresh();
    if (!timer) {
      timer = window.setInterval(refreshAll, 1000);
      window.addEventListener('focus', refreshAll);
      document.addEventListener('visibilitychange', refreshAll);
    }
  }

  function unregister(instance) {
    instances.delete(instance);
    if (!instances.size) {
      window.clearInterval(timer);
      timer = undefined;
      window.removeEventListener('focus', refreshAll);
      document.removeEventListener('visibilitychange', refreshAll);
    }
  }

  class PreorderShopper extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('[data-preorder-scope]');
      this.link = this.querySelector('a');
      if (!this.scope || !this.link) return;
      this.onSubmit = (event) => {
        this.refresh();
        if (this.hidden) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.link.click();
      };
      this.onClick = (event) => {
        this.refresh();
        // If the shift just ended, restore the cart controls without opening WhatsApp.
        if (this.hidden) {
          event.preventDefault();
          this.scope.querySelector('[type="submit"]')?.focus();
        }
      };
      this.onChange = () => this.updateLink();
      this.scope.addEventListener('submit', this.onSubmit, true);
      this.scope.addEventListener('change', this.onChange);
      this.link.addEventListener('click', this.onClick);
      register(this);
    }

    disconnectedCallback() {
      this.scope?.removeEventListener('submit', this.onSubmit, true);
      this.scope?.removeEventListener('change', this.onChange);
      this.link?.removeEventListener('click', this.onClick);
      unregister(this);
    }

    refresh(open = isOpen()) {
      this.hidden = !open;
      this.scope.toggleAttribute('data-preorder-open', open);
      this.updateLink();
    }

    updateLink() {
      const url = new URL(this.dataset.productUrl, window.location.origin);
      const variantScope = (this.dataset.variantFormId && document.getElementById(this.dataset.variantFormId)) || this.scope;
      const variant = variantScope.querySelector('input[name="id"]')?.value;
      if (variant) url.searchParams.set('variant', variant);
      const message = `Olá! Quero comprar o produto ${this.dataset.productTitle} em pré-venda com uma Personal Shopper. ${url.href}`;
      this.link.href = `https://wa.me/${this.dataset.phone}?text=${encodeURIComponent(message)}`;
    }
  }

  customElements.define('preorder-shopper', PreorderShopper);

  class ScheduledWhatsapp extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('a');
      this.form = this.closest('form');
      if (!this.link || !this.form) return;
      this.onChange = () => this.updateLink();
      this.onClick = event => {
        this.refresh();
        if (this.hidden) event.preventDefault();
      };
      this.form.addEventListener('change', this.onChange);
      this.link.addEventListener('click', this.onClick);
      register(this);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('change', this.onChange);
      this.link?.removeEventListener('click', this.onClick);
      unregister(this);
    }

    refresh(open = isOpen()) {
      this.hidden = !open;
      if (open) this.updateLink();
    }

    updateLink() {
      const url = new URL(this.dataset.productUrl, window.location.origin);
      const variant = this.form.querySelector('input[name="id"]')?.value;
      if (variant) url.searchParams.set('variant', variant);
      const message = `Olá! Quero comprar o produto ${this.dataset.productTitle}. ${url.href}`;
      this.link.href = `https://wa.me/${this.dataset.phone}?text=${encodeURIComponent(message)}`;
    }
  }

  customElements.define('scheduled-whatsapp', ScheduledWhatsapp);
})();
